import { combineReducers } from 'redux';

import { reducer as list } from './listModule';
import { reducer as compare } from './compareModule';

export default combineReducers({
	list,
	compare,
});
